/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Machines from '../assets/machines.json'
import getRate from '../services/getRate.service'
import Contact from './Contact'
import DataTable from './DataTable'
import { Print } from '@material-ui/icons';
import './newCalculation.css'
import { db } from '../config/fbConfig'
import { doc, setDoc } from 'firebase/firestore'
import '../app.css';



const AddNewCalculation = ({ projectId, kitchen, dbProject }) => {

  const [coversList, setCoversList] = useState([1, 2])
  const [cover, setCover] = useState(1)
  const [machine, setMachine] = useState('Fritös')
  const [effect, setEffect] = useState('')
  const [quantity, setQuantity] = useState('')
  const [rate, setRate] = useState('')
  const [project, setProject] = useState({
    name: '',
    covers: {}
  })


  const addToProject = () => {

    const covers = project.covers
    if (covers.hasOwnProperty(cover)) {
      covers[cover].push({ machine, effect, quantity, exhaustAir: effect * quantity * rate })
      return setProject({ ...project, name: kitchen, })
    }
    setCoversList([...coversList, coversList.length + 1])
    covers[cover] = [{ machine, effect, quantity, exhaustAir: effect * quantity * rate }]
    return setProject({ ...project, name: kitchen, })

  }

  const deleteFromProject = (coverIndex, rowIndex) => {

    const covers = project.covers
    const currentCover = project.covers[coverIndex]
    currentCover.splice(rowIndex, 1)

    if (currentCover.length > 0) {
      covers[coverIndex] = currentCover
      setProject({ ...project })
      return setDoc(doc(db, "projects", projectId), project);

    } else {
      delete covers[coverIndex]
      setProject({ ...project })
      setDoc(doc(db, "projects", projectId), project);
    }

  }

  const changeBtnState = () => {
    if (typeof machine !== undefined && effect !== '' && quantity !== '') {
      return false
    }
    return true
  }

  useEffect(() => {
    const initRate = getRate(kitchen, machine)
    setRate(initRate)
    setProject({ ...project, name: kitchen })
    changeBtnState()
  }, [machine, effect, quantity, kitchen])

  useEffect(() => {
    dbProject.hasOwnProperty('covers') ? setProject({ name: dbProject.name, covers: dbProject.covers })
      : setProject({ ...project, name: dbProject.name })
  }, [dbProject])

  const handleQuantityChange = (e) => {
    setQuantity(e.target.value)
  }
  const handleEffectChange = (e) => {
    setEffect((e.target.value))
  }
  const handleMachineChange = (e) => {
    setMachine((e.target.value))
  }

  const handleCoverChange = (e) => {
    setCover(e.target.value)
  }

  const print = () => {
    window.print();
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    addToProject()
    setDoc(doc(db, "projects", projectId), project);
  }

  return (
    <>
      <form>
        <div className='inputsContainer'>
          <div className='inputsContainer-children'>
            <label htmlFor='choose-cover'>Kåpa</label>
            <select id='choose-cover' onChange={handleCoverChange} value={cover}>
              {coversList.map((cover, i) => <option value={cover} key={i}>{cover}</option>)}
            </select>
          </div>
          <div className='inputsContainer-children'>
            <label htmlFor='choose-machine'>Välj köksmaskin</label>
            <select id='choose-machine' onChange={handleMachineChange} value={machine}>
              {Machines.map((machine, i) => <option value={machine} key={i}>{machine}</option>)}
            </select>
          </div>
          <div className='inputsContainer-children'>
            <label htmlFor='effect'>Effekt(kW)</label>
            <input id='effect' type='number' value={effect} onChange={handleEffectChange}></input>
          </div>
          <div className='inputsContainer-children'>
            <label htmlFor='quantity'>Antal</label>
            <input id='quantity' type='number' value={quantity} onChange={handleQuantityChange}></input>
          </div>
          <div className='inputsContainer-children'>
            <label htmlFor='button'></label>
            <button id='button' onClick={handleSubmit} disabled={changeBtnState()}
              className={effect !== '' && quantity !== '' && machine !== undefined ? 'btn-active' : 'btn-disabled'}>
              Lägg till</button>
          </div>
        </div>
        <div className='dataTableContainer'>
          {Object.entries(project.covers).map(([key, value], i) => <DataTable array={project.covers[key]} coverIndex={key} removeRow={deleteFromProject} key={i} />)}
        </div>
      </form>
      <div className='icon-container' onClick={print}>
        <Print className='printIcon' fontSize='medium' />
        <span>Skriv ut</span>
      </div>
      {Object.entries(project.covers).length > 0 &&
        <div>
          <Contact projectId={projectId} />
        </div>
      }



    </>
  )
}

export default AddNewCalculation
